import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";

const DisciplinesTable = ({ disciplines }) => (
  <Box sx={{ maxHeight: "220px", overflowY: "auto" }}>
    <Table
      size="small"
      stickyHeader
    >
      <TableHead>
        <TableRow>
          <TableCell>Дисциплина</TableCell>
          <TableCell width="25%">Семестър</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {disciplines.map(discipline => (
          <TableRow key={`${discipline.disciplineId}-${discipline.semester}`}>
            <TableCell>{discipline.disciplineName}</TableCell>
            <TableCell>{discipline.semester ?? "-"}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </Box>
);

const PreviewSection = ({ title, hint, disciplines }) => (
  <Box sx={{ mt: 2 }}>
    <Typography
      color="primary"
      sx={{ fontWeight: "bold" }}
    >
      {`${title} (${disciplines?.length ?? 0})`}
    </Typography>
    <Typography
      variant="body2"
      sx={{ mb: 1 }}
    >
      {hint}
    </Typography>
    {disciplines?.length ? (
      <DisciplinesTable disciplines={disciplines} />
    ) : (
      <Typography variant="body2">Няма дисциплини.</Typography>
    )}
  </Box>
);

const CurriculumTransferPreview = ({ preview }) => {
  if (!preview) return null;

  return (
    <>
      <PreviewSection
        title="Общи дисциплини"
        hint="Оценките по тези дисциплини се прехвърлят автоматично в новия учебен план."
        disciplines={preview.commonDisciplines}
      />
      <PreviewSection
        title="Дисциплини само в новия учебен план"
        hint="Тези дисциплини липсват в текущия учебен план и ще бъдат добавени като индивидуален учебен план на студента."
        disciplines={preview.newDisciplinesRequiringIndividualPlan}
      />
    </>
  );
};

export default CurriculumTransferPreview;
